// Static site utilities bundle entry point.
//
// Embed widgets (eSign trigger, shop cart, share toolbar, form uploads,
// floating toolbar) come from @r2ware/sdk, which self-initializes on load.
// What stays here is the platform-served surface the SDK intentionally does
// not own: the dashboard Stimulus controllers, the carousel splitter, the
// eSign sign/complete signing-return pages, and the cart *page* controller
// (the SDK ships the embeddable cart client; the cart page is rendered by
// the platform and reads the cart storage API from window.R2.Cart).

import '@r2ware/sdk'
import '@r2ware/sdk/style'
import { application } from '../controllers/application.js'
import '../controllers/index.js'
import '../carousel/index.js'
import '../esign/index.js'

// The cart page (/app/shop/cart) is platform-served; its controller stays in
// dash. It reads the cart storage API from the SDK via window.R2.Cart.
import CartController from '../controllers/cart_controller.js'
application.register('cart', CartController)
